import React from "react";

export interface DataPanelProps {
  title: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  exportData?: Record<string, any>[];
  onExport?: () => void;
}

// Accent falls back to Search violet until a card sets --accent on an ancestor.
const ACCENT = "var(--accent, #8B5CF6)";

const DataPanel: React.FC<DataPanelProps> = ({
  title,
  icon,
  actions,
  children,
  className = "",
}) => {
  return (
    <div className={`overflow-hidden rounded-2xl border border-white/[0.07] bg-og01-card ${className}`}>
      {/* Header */}
      <div className="flex items-center gap-3 border-b border-white/[0.07] px-5 py-[18px]">
        {icon && (
          <span
            className="grid h-[30px] w-[30px] flex-none place-items-center rounded-lg"
            style={{ background: `color-mix(in srgb, ${ACCENT} 14%, transparent)`, color: ACCENT }}
          >
            {icon}
          </span>
        )}
        <h3 className="flex-1 font-heading text-[18px] text-og01-text">{title}</h3>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>

      {/* Content */}
      <div className="px-5 pb-5 pt-4">{children}</div>
    </div>
  );
};

export default DataPanel;
